import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { Typography } from '@mui/material';

const QuestionsInformation = ({ detail }) => (
  <div className='flex flex-nowrap gap-4 pb-2 items-strech justify-center overflow-auto'>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Order</TableCell>
            <TableCell>Question</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Variant</TableCell>
            <TableCell>Options</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detail?.questions?.length > 0 ? (
            detail.questions.map((question, index) => {
              const { options = [] } = question;
              const questionsString = options.map((option) => option?.option || option?.value).join(', ');

              return (
                <TableRow key={`table-columd-body-${question}-${index}`}>
                  <TableCell width={100} className='overflow-hidden'>
                    <Typography variant='body2' component={'span'}>
                      {question?.order || index + 1}
                    </Typography>
                  </TableCell>
                  <TableCell width={300} className='overflow-hidden'>
                    <Typography variant='body2' component={'span'}>
                      {question?.title}
                    </Typography>
                  </TableCell>
                  <TableCell width={100} className='overflow-hidden'>
                    <Typography variant='body2' component={'span'}>
                      {question?.type?.value}
                    </Typography>
                  </TableCell>
                  <TableCell width={100} className='overflow-hidden'>
                    <Typography variant='body2' component={'span'}>
                      {question?.variant?.value}
                    </Typography>
                  </TableCell>
                  <TableCell className='overflow-hidden max-w-300px' width={300}>
                    <Typography variant='body2' component={'span'}>
                      {questionsString}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={3}>
                <Typography
                  color='inherit'
                  component={'p'}
                  className='text-muted-foreground opacity-50 py-2 text-center'
                >
                  You don't have any questions yet
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </div>
);

export default QuestionsInformation;
